import { render } from "./GroupTags.vue?vue&type=template&id=1cde9a90"
import script from "./GroupTags.vue?vue&type=script&lang=js"
export * from "./GroupTags.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__